function SearchBar(props) {
	function ContinentBox(index, name, code, checked) {
		const onChange = evt => {
			// Need to make a (shallow) copy here, because the set* function returned
			// by useState seemingly ignores the change if the new object has the same
			// identity as the old object
			let newContinents = [...props.continents];
			newContinents[index][2] = evt.target.checked;
			props.onChange(newContinents);
		};

		return (<label key={index}>
			<input type="checkbox" checked={checked} onChange={onChange} />{name}
		</label>);
	}

	return (<span>
		{props.continents.map((cont, i) => ContinentBox(i, cont[0], cont[1], cont[2]))}
	</span>);
}

export default SearchBar;
